import { useQuery } from "@apollo/client";
import { SALE_DETAIL } from "../apollo/queries";

const useViewSale = ({ id, downloadInvoice }) => {

    const { data, loading, refetch } = useQuery(SALE_DETAIL, {
        variables: {
            getSaleId: id ?? null,
        },
        skip: !id,
        fetchPolicy: "network-only",
    });

    return {
        values: {
            data: data?.getSale ?? null,
            loading
        },
        functions: {
            refetch,
            onDownload: () => downloadInvoice(id)
        }
    }
}

export default useViewSale